import { AuthVersionState } from "../state/authVersionState";
import { PropsWithChildren } from "react";
import { satisfies } from "semver";
import { AuthProvider as AuthProviderV1 } from "./version1/AuthProvider/AuthProvider";
import { AuthProvider as AuthProviderV2 } from "./version2/AuthProvider/AuthProvider";

interface VersionedAuthProviderProps extends PropsWithChildren {
  appVersion: string;
}

export const VersionedAuthProvider = ({ appVersion, children }: VersionedAuthProviderProps) => {
  const useLatestAuth = satisfies(appVersion, process.env.REACT_APP_NEW_AUTH_VERSION!);
  const isMobile = !!window.flutter_inappwebview;

  if ((isMobile && useLatestAuth) || !isMobile) {
    AuthVersionState.set("latest");
    return <AuthProviderV2>{children}</AuthProviderV2>;
  } else {
    AuthVersionState.set("old");
    return <AuthProviderV1>{children}</AuthProviderV1>;
  }
};
